<template>
  <!-- TODO: Traiter surTitre,titre et sousTitre -->
  <div v-if="isLienActif" class="d-flex flex-column" :class="jel_getClassObject(content)">
    <span @click.capture="gaPreventClick">
      <b-link v-bind="jel_getLienBinding(content.lien)">
        <b-img-lazy :src="jel_getFichierSrc(content.image)" :alt="content.altImage" />
      </b-link>
    </span>
  </div>
  <div v-else class="d-flex flex-column">
    <b-img-lazy
      :src="jel_getFichierSrc(content.image)"
      :alt="content.altImage"
      :class="content.cssImage"
    />
  </div>
</template>

<script>
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

export default {
  name: 'MediaImageSimple',
  props: { content: { type: Object, required: true } },
  computed: {
    isLienActif() {
      if (
        !this.content.lien ||
        (this.content.lien.field && this.content.lien.field === 'aucunLien')
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    gaPreventClick() {
      const event = 'ga-pp-click';
      const categorie = 'PP - Pied de page';
      const libelle = `Lien ${this.content.altImage}`;
      if (this.content.lien && this.content.lien.field == 'lienExterne') {
        // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event,
          categorie,
          emplacement: `${this.jel_gaGetEmplacement()}`,
          libelle,
        });
      }
    },
  },
};
</script>
